import React from "react";
import { State } from "../../components/trials/context";
import { Trials } from "../../components/trials";

import SEO from "../../components/seo";
import Layout from "../../components/layout";

const TrialsPage = () => {

  return (
    <Layout>
      <SEO title="Trials" />
      <State>
        <Trials/>
      </State>
    </Layout>
  );
};

export default TrialsPage;
